import Image from 'next/image';
import Pin from 'public/pin.svg';
import { PickupPoint } from 'types/Checkout';
import { SubCollapseIcon } from '../CheckoutSteps/CheckoutSteps.styled';
import { BrandData, BrandLogo, Card, CheckActive, Div, Info, Logo, Name, P, Wrapper } from './PickupPointCard.styled';

interface Props {
  data: PickupPoint;
  onClick: React.Dispatch<React.SetStateAction<number | undefined>>;
  isSelected: boolean;
  isDisabled: boolean;
}

export default function PickupPointCard({ data, onClick, isSelected, isDisabled }: Props) {
  return (
    <Wrapper htmlFor={data.id + '_PICK_UP'} onClick={() => !isSelected && onClick(data.id)} isDisabled={isDisabled}>
      <input type="radio" name={'PICK_UP_POINT'} id={data.id + '_PICK_UP'} checked={isSelected} />
      <CheckActive />
      <Card>
        <BrandLogo>
          <Logo>
            <SubCollapseIcon icon="garage.svg" />
          </Logo>
        </BrandLogo>
        <BrandData>
          <Name>{data.name}</Name>
          <Info>
            <Div>
              <Image src={Pin} width={16.18} height={20} alt="pin" />
            </Div>
            <P>{data.address}</P>
          </Info>
        </BrandData>
      </Card>
    </Wrapper>
  );
}
